module.exports = "span {\n  margin: 25px;\n  text-align: justify; }\n\np {\n  margin-right: 30px; }\n"